export const RESOURCE_TYPE_NAVIGATION_PLANS_VISIBILITY = 'NAVIGATION_PLANS_VISIBILITY';
export const LOCATION = 'portfolio.services.plan-item-visibility';
